module.exports = __webpack_public_path__ + "static/solar-06ab34fbe1aa0230cea25b37c17a42e5.jpg";